import { Link } from "react-router-dom";
import { SimpleParagraph } from "./Components/common/Paragraph";
import style from "./App.less";

export const ROLES = {
  admin: "SUPER ADMIN",
  user: "CUSTOMER",
  shopkeeper: "SHOPKEEPER",
  default: "default",
};

export const ALL_HEADER_CONSTANTS = {
  [ROLES.admin]: [],
  [ROLES.shopkeeper]: [
    {
      label: (
        <Link to='/car-listing'>
          <SimpleParagraph
            paragraph='MY CARS'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "car-listing",
    },
    {
      label: (
        <Link to='/shopkeeper-bookings'>
          <SimpleParagraph
            paragraph='MY BOOKINGS'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "shopkeeper-bookings",
    },
    {
      label: (
        <Link to='/edit-shop-details'>
          <SimpleParagraph
            paragraph='EDIT SHOP'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "edit-shop-details",
    },
  ],
  [ROLES.user]: [
    {
      label: (
        <Link to='/categories'>
          <SimpleParagraph
            paragraph='BROWSE BY CARS'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "categories",
    },
    {
      label: (
        <Link to='/brands'>
          <SimpleParagraph
            paragraph='BROWSE BY BRANDS'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "mail",
    },
    {
      label: (
        <Link to='/car-pooling'>
          <SimpleParagraph
            paragraph='CAR POOL'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "car-pooling",
    },
    {
      label: (
        <Link to='/my-poolings'>
          <SimpleParagraph
            paragraph='MY POOLINGS'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "my-car-pooling",
    },
    {
      label: (
        <SimpleParagraph
          paragraph='REQUEST'
          size='14'
          bold
          css={style.letterSpacing}
        />
      ),
      key: "request",
      children: [
        {
          label: (
            <Link to='/pooling-request'>
              <SimpleParagraph
                paragraph='POOLING REQUEST'
                size='12'
                bold
                css={style.letterSpacing}
              />
            </Link>
          ),
          key: "pooling-request",
        },
        {
          label: (
            <Link to='/my-bookings'>
              <SimpleParagraph
                paragraph='BOOKING REQUEST'
                size='12'
                bold
                css={style.letterSpacing}
              />
            </Link>
          ),
          key: "booking-request",
        },
      ],
    },
    {
      label: (
        <Link to='/edit-customer-profile'>
          <SimpleParagraph
            paragraph='PROFILE'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "edit-profile",
    },
  ],
  [ROLES.default]: [
    {
      label: (
        <Link to='/categories'>
          <SimpleParagraph
            paragraph='BROWSE BY CARS'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "categories",
    },
    {
      label: (
        <Link to='/brands'>
          <SimpleParagraph
            paragraph='BROWSE BY BRANDS'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "mail",
    },
    {
      label: (
        <Link to='/car-pooling'>
          <SimpleParagraph
            paragraph='CAR POOL'
            size='14'
            bold
            css={style.letterSpacing}
          />
        </Link>
      ),
      key: "car-pooling",
    },
  ],
};
